import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'dcc-cohort-owner-input',
  templateUrl: './cohort-owner-input.component.html',
  styleUrls: ['./cohort-owner-input.component.scss'],
})
export class CohortOwnerInputComponent implements OnInit, OnChanges, OnDestroy {
  @Input() placeHolder: string;
  @Input() owner: string;

  @Output()
  wordTyped: EventEmitter<string> = new EventEmitter<string>();

  inputValue: string;

  private searchSubject = new Subject<string>();
  private subscription: Subscription;

  ngOnInit(): void {
    this.inputValue = this.owner;
    this.subscription = this.searchSubject
      .pipe(debounceTime(200)) // Debounce for 200ms
      .subscribe((searchTerm: string) => {
        this.wordTyped.emit(searchTerm); // Emit the debounced value
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cohortName']) {
      this.inputValue = this.owner;
    }
  }

  onInput(): void {
    this.searchSubject.next(this.inputValue);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
